import React from "react";
import { Modal, Row, Col } from "antd";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalNewCarAreaDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="New Car Area Detail"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>New Car Area Detail</p>

        <RowForm>
          <Col span={8}>Area Name</Col>
          <Col span={16}>: {data ? data.name : null}</Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalNewCarAreaDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Area/NewCarArea/ModalNewCarAreaDetail.js